import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
const LoadingScreen: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      className="transition-colors"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{
        background: `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`
      }}
    >
      <Box
        component="img"
        src="/jugglevision-logo-nobg-dark.svg"
        srcSet="/jugglevision-logo-nobg-dark.svg 1x, /jugglevision-logo-nobg-dark.svg 2x"
        sizes="(max-width: 240px) 100vw, 240px"
        alt="JuggleVision"
        loading="eager"
        sx={{ width: 240, height: 'auto', mb: 3, maxWidth: '80vw' }}
      />
      <CircularProgress size={60} sx={{ color: theme.palette.primary.main }} />
    </Box>
  );
};

export default LoadingScreen;
